<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-02 20:59:27
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>规则管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">规则列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="标题">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="标题" align="center">
          </el-table-column>
          <el-table-column label="分类" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">截单设置</span>
              <span v-if="scope.row.type == 1">派单设置</span>
              <span v-if="scope.row.type == 2">回访设置</span>
            </template>
          </el-table-column>
          <el-table-column label="规则内容" align="center" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.type == 0">
                <div>
                  发布人类型：<span class="decoration">{{
                    scope.row.cutRule.publisherType == 0
                      ? "所有"
                      : scope.row.cutRule.publisherType == 1
                      ? "个人"
                      : "企业"
                  }}</span>
                </div>
                <div>
                  地区：<span class="decoration">{{
                    scope.row.cutRule.cityName
                  }}</span>
                </div>
                <div>
                  总金额：<span class="decoration">{{
                    scope.row.cutRule.moneyValue
                  }}</span>
                </div>
                <div>
                  截停时间：<span class="decoration">{{
                    scope.row.cutRule.cutTimeValue | maxTime
                  }}</span>
                </div>
              </div>
              <div v-if="scope.row.type == 1">
                <div>
                  显示结束时间：<span class="decoration">{{
                    scope.row.dispatchRule.dispatchEndTimeValue | maxTime
                  }}</span>
                </div>
              </div>
              <div v-if="scope.row.type == 2">
                <div>
                  回访时间要求：<span class="decoration">{{
                    scope.row.followupRule.followupRequireTimeValue | maxTime
                  }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.publishTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div class="operateBtn" @click="edit(scope.row)">编辑</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="630px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <div v-if="type == 0">
          <el-form-item label="发布人类型" prop="type">
            <el-select v-model="ruleForm1.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布区域" prop="region">
            <el-select v-model="ruleForm1.region" placeholder="请选择">
              <el-option
                v-for="item in city"
                :key="item.adcode"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额大于" prop="money">
            <el-input v-model="ruleForm1.money" placeholder="请输入金额"
              ><template slot="append">以上</template></el-input
            >
          </el-form-item>
          <el-form-item label="截停时间" prop="time">
            <el-input v-model="ruleForm1.time" placeholder="请输入截停时间"
              ><template slot="append">分钟</template></el-input
            >
            <div style="flex: none; margin-left: 10px">
              {{ ruleForm1.time == "" ? "" : ruleForm1.time | maxTime }}
            </div>
          </el-form-item>
        </div>
        <div v-if="type == 1">
          <el-form-item label="截停时间" prop="time1">
            <el-input v-model="ruleForm1.time1" placeholder="请输入截停时间"
              ><template slot="append">分钟</template></el-input
            >
            <div style="flex: none; margin-left: 10px">
              {{ ruleForm1.time1 == "" ? "" : ruleForm1.time1 | maxTime }}
            </div>
          </el-form-item>
        </div>
        <div v-if="type == 2">
          <el-form-item label="截停时间" prop="time2">
            <el-input v-model="ruleForm1.time2" placeholder="请输入截停时间"
              ><template slot="append">分钟</template></el-input
            >
            <div style="flex: none; margin-left: 10px">
              {{ ruleForm1.time2 == "" ? "" : ruleForm1.time2 | maxTime }}
            </div>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "新增规则",
      ruleForm1: {
        type: "",
        region: "",
        money: "",
        time: "",
        time1: "",
        time2: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        region: [{ required: true, message: "必选项", trigger: "change" }],
        time: [{ required: true, message: "必选项", trigger: "change" }],
        time1: [{ required: true, message: "必选项", trigger: "change" }],
        time2: [{ required: true, message: "必选项", trigger: "change" }],
        money: [{ required: true, message: "必选项", trigger: "change" }],
      },
      options: [
        { label: "所有", value: "0" },
        { label: "个人", value: "1" },
        { label: "企业", value: "2" },
      ],
      editId: "", // 修改id
      type: "", //修改数据的类型
      moneyList: [], //金额列表
      timeList: [], //截单时间列表
      time: [], //截单时间列表
      time1: [], //截单时间列表
      city: [], //区域列表
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {};
          if (this.type == 0) {
            let obj = {
              cityAdcode: this.ruleForm1.region,
              cutTimeValue: this.ruleForm1.time,
              moneyValue: this.ruleForm1.money,
              publisherType: this.ruleForm1.type,
            };
            param.cutRule = obj;
          }
          if (this.type == 1) {
            let obj = {
              dispatchEndTimeValue: this.ruleForm1.time1,
            };
            param.dispatchRule = obj;
          }
          if (this.type == 2) {
            let obj = {
              followupRequireTimeValue: this.ruleForm1.time2,
            };
            param.followupRule = obj;
          }
          if (this.editId == "") {
          } else {
            param.id = this.editId;
            param.type = this.type;
            this.$axios
              .post(`/admapi/setrule/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/setrule/list`, param)
        .then(({ data }) => {
          this.tableData = data;
          // this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    edit(val) {
      this.editId = val.id;
      this.type = val.type;
      if (val.type == 0) {
        this.ruleForm1.type = JSON.stringify(val.cutRule.publisherType);
        this.ruleForm1.region = val.cutRule.cityAdcode;
        this.ruleForm1.money = val.cutRule.moneyValue;
        this.ruleForm1.time = val.cutRule.cutTimeValue;
        // this.getMoneyList();
        // this.getTimeList();
        this.getcity();
      }
      if (val.type == 1) {
        this.ruleForm1.time1 = val.dispatchRule.dispatchEndTimeValue;
        this.getTime();
      }
      if (val.type == 2) {
        this.ruleForm1.time2 = val.followupRule.followupRequireTimeValue;
        this.getTime1();
      }
      this.title = "编辑规则";
      this.dialogFormVisible = true;
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/setrule/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    getMoneyList() {
      let param = {
        key: "setRuleCutMoney",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.moneyList = data;
        })
        .catch()
        .finally();
    },
    getTimeList() {
      let param = {
        key: "setRuleCutTime",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.timeList = data;
        })
        .catch()
        .finally();
    },
    getTime() {
      let param = {
        key: "setRuleDispatchEndTime",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.time = data;
        })
        .catch()
        .finally();
    },
    getTime1() {
      let param = {
        key: "setRuleFollowupRequireTime",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.time1 = data;
        })
        .catch()
        .finally();
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let obj = {
            name: "全国",
            adcode: "100000",
          };
          data.unshift(obj);
          this.city = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped></style>
